const initialPpcState = {
  isFetching: true,
  conversion_rate: 0,
  cost_per_lead: 0,
  total_clicks: 0,
  total_cost: 0,
  total_impressions: 0,
  total_conversions: 0,
  total_conversions_by_campaign: {},
  total_conversions_by_location: {},
  month_labels: [],
  cost_per_lead_by_month: [],
  calls_forms_by_month: [],
  campaigns: {},
  locations: {},
  campaigns_total: 0,
  locations_total: 0,
  conversion_rate_change: 0,
  cost_per_lead_change: 0,
  total_clicks_change: 0,
  total_cost_change: 0,
  total_impressions_change: 0,
  total_conversions_change: 0,
};

const ppcActions = {
  PPC_SET_ALL: 'PPC_SET_ALL',
  PPC_SET_IS_FETCHING: 'PPC_SET_IS_FETCHING',
  PPC_SET_EMPTY: 'PPC_SET_EMPTY',
  PPC_SET_CAMPAIGNS: 'PPC_SET_CAMPAIGNS',
  PPC_CLEAN: 'PPC_CLEAN',
};

function ppcReducer(state, action) {
  const newState = { ...state };
  switch (action.type) {
    case ppcActions.PPC_SET_ALL:
      if (action.payload.ppc) {
        newState.isFetching = action.payload.isFetching;
        newState.conversion_rate = action.payload.ppc.conversion_rate;
        newState.cost_per_lead = action.payload.ppc.cost_per_lead;
        newState.total_clicks = action.payload.ppc.total_clicks;
        newState.total_cost = action.payload.ppc.total_cost;
        newState.total_impressions = action.payload.ppc.total_impressions;
        newState.total_conversions = action.payload.ppc.total_conversions;
        newState.total_conversions_by_campaign = action.payload.ppc.total_conversions_by_campaign;
        newState.total_conversions_by_location = action.payload.ppc.total_conversions_by_location;
      }
      return { ...newState, ...action.payload };
    case ppcActions.PPC_SET_IS_FETCHING:
      return { ...state, isFetching: action.payload.isFetching };
    case ppcActions.PPC_CLEAN:
      return {
        ...initialPpcState,
      };
    case ppcActions.PPC_SET_EMPTY:
      return {
        ...initialPpcState,
        isFetching: false,
      };
    case ppcActions.PPC_SET_CAMPAIGNS:
      newState.isFetching = action.payload.isFetching;
      if (action.payload.campaigns) {
        newState.campaigns = action.payload.campaigns;
        newState.campaigns_total = action.payload.campaigns_total; // todo:
      }
      if (action.payload.locations) {
        newState.locations = action.payload.locations;
        newState.locations_total = action.payload.locations_total; // todo:
      }
      return { ...newState, ...action.payload };
    default:
      return state;
  }
}

export { initialPpcState, ppcActions, ppcReducer };
